import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import NewUserForm from '../create-form'
import Modal from '../../modals/wrapper'
import { Tabs, Tab } from 'react-bootstrap'
import { capitalize } from 'lodash'
import ImportForm from '../import-form'

const MODES = {
    INDIVIDUAL: 'individual',
    MULTIPLE: 'multiple',
}

const UserCreateModal = ({
    onHide = () => {}
}) => {

    const [ mode, setMode ] = useState(MODES.INDIVIDUAL)

    return createPortal(
        <Modal
            closeButton
            onHide={onHide}
            size='lg'
            fullWidth={mode === MODES.MULTIPLE}
        >
            <div
                style={{ padding: '40px' }}
            >
                <div>
                    <h2><strong>Add New {mode === MODES.INDIVIDUAL ? 'User' : 'Users'}</strong></h2>
                </div>
                <div>
                    <Tabs activeKey={mode} onSelect={setMode} >
                        <Tab eventKey={MODES.INDIVIDUAL} title={capitalize(MODES.INDIVIDUAL)}>
                            <NewUserForm onComplete={onHide} />
                        </Tab>
                        <Tab eventKey={MODES.MULTIPLE} title={capitalize(MODES.MULTIPLE)}>
                            <ImportForm onComplete={onHide} />
                        </Tab>
                    </Tabs>
                </div>
            </div>
            
        </Modal>
        , document.body)
}

export default UserCreateModal